import { Component, Input } from '@angular/core';
import { Bildungsanbieter } from '../../../../../model/bildungsanbieter';
import { FocusableIfVisibleDirective } from '../../../../../shared/directives/focusable-if-visible.directive';

@Component({
  selector: 'now-wbsuche-lib-bildungsanbieter',
  templateUrl: './bildungsanbieter.component.html',
  styleUrls: ['./bildungsanbieter.component.scss'],
  imports: [FocusableIfVisibleDirective]
})
export class BildungsanbieterComponent {
  @Input({ required: true })
  public anbieter!: Bildungsanbieter;

  @Input()
  public collapsed?: boolean;

  get telefonnummer(): string {
    return this.getTelefon(this.anbieter.telefonVorwahl, this.anbieter.telefon);
  }

  get telefonnummerHref(): string {
    return this.getTelefonHref(this.anbieter.telefonVorwahl, this.anbieter.telefon);
  }

  get mobilnummer(): string {
    return this.getTelefon(this.anbieter.mobilVorwahl, this.anbieter.mobil);
  }

  get mobilnummerHref(): string {
    return this.getTelefonHref(this.anbieter.mobilVorwahl, this.anbieter.mobil);
  }

  get faxnummer(): string {
    return this.getTelefon(this.anbieter.faxVorwahl, this.anbieter.faxDurchwahl);
  }

  get faxnummerHref(): string {
    return this.getTelefonHref(this.anbieter.faxVorwahl, this.anbieter.faxDurchwahl);
  }

  private getTelefonHref(vorwahl: string, durchwahl: string): string {
    const tel = [vorwahl, durchwahl].join('').trim();
    return `tel: ` + tel;
  }

  private getTelefon(vorwahl: string, durchwahl: string): string {
    if (vorwahl) {
      return `${vorwahl} / ${durchwahl}`;
    } else {
      return durchwahl;
    }
  }
}
